// extracted by mini-css-extract-plugin
export default {"pageName":"PageName__pageName___DMJlv"};